function parseAutocompleteWithApiAsAddress(place) {
    const country = place.country;
    const address = place.label;
    const latitude = place.latitude;
    const longitude = place.longitude;
    return {
        calizyAddress: address,
        post_code: place.post_code,
        address,
        country,
        latitude,
        longitude,
    };
}
export { parseAutocompleteWithApiAsAddress, };
